import { usePermissionContext } from "../context/PermissionContext";
import {
  can as canDirect,
  getEffectiveScope,
  getVisibilityLevel,
  CAPABILITY,
  DATA_SCOPE,
  VISIBILITY,
} from "../helpers/permissions";

/**
 * Access permission APIs within React components.
 * Returns no-op denials when used outside PermissionProvider (e.g. tests).
 */
export function usePermissions() {
  const context = usePermissionContext();

  if (context) {
    return {
      actor: context.actor,
      orgPolicies: context.orgPolicies,
      directReportIds: context.directReportIds ?? [],
      can: context.can,
      assertCan: context.assertCan,
      getPermission: context.getPermission,
      visibility: context.visibility,
      scope: context.scope,
      isHidden: context.isHidden,
      isReadOnly: context.isReadOnly,
      CAPABILITY,
      DATA_SCOPE,
      VISIBILITY,
    };
  }

  return {
    actor: null,
    orgPolicies: null,
    directReportIds: [],
    can: () => false,
    assertCan: () => {
      throw new Error("PermissionProvider is not mounted");
    },
    getPermission: () => ({
      allowed: false,
      scope: null,
      visibility: VISIBILITY.HIDDEN,
    }),
    visibility: () => VISIBILITY.HIDDEN,
    scope: () => null,
    isHidden: () => true,
    isReadOnly: () => true,
    CAPABILITY,
    DATA_SCOPE,
    VISIBILITY,
  };
}

export { canDirect as can, getEffectiveScope, getVisibilityLevel };
